import utility from 'src/utils/utility'
import CustomerManagement from 'src/app/dashboardv2/customerManagement'

// CustomerManagement renders one of three views off a `view` prop rather than
// being a single-route page like the rest of dashboardv2, so it needs three
// separate routeData entries (one per nav path) instead of one default export.
//
// NOTE: verify the path these keys resolve to against how utility.routeData
// builds routeProps.path elsewhere (e.g. whether it supports a '/' inside the
// key for nesting, like 'customer-management/list', or only flattens it, like
// 'customer-management-list' below). Adjust the key strings if the resulting
// URLs don't land on /dashboardv2/customer-management/list etc.

export const CustomerListRoute = utility.routeData(
    'customer-management-list',
    'Customer List',
    <CustomerManagement view="list" />,
)

export const CbpCustomerListRoute = utility.routeData(
    'customer-management-cbp-list',
    'CBP Customer List',
    <CustomerManagement view="cbp-list" />,
)

export const AccountUpgradeRoute = utility.routeData(
    'customer-management-account-upgrade',
    'Account Upgrade',
    <CustomerManagement view="account-upgrade" />,
)